import * as styles from "./ParagraphSponsorMePromoCard.module.scss";

import { graphql } from "gatsby";
import React from "react";
import SponsorDogPromoCard, {
	type SponsorDogPromoCardProps,
} from "../../../components/SignPostCards/SponsorDogPromoCard/SponsorDogPromoCard";
import WrappedSection from "../../WrappedSection/WrappedSection";

interface ParagraphSponsorMePromoCardProps {
	card: SponsorDogPromoCardProps;
}
export const getParagraphSponsorMePromoCardProps = ({
	relationships: {
		field_sponsor_dog: {
			path: { alias },
			field_promo_short_text,
			relationships: {
				field_featured_image: {
					field_media_image: { uri: imgSrc, alt: imgAlt },
				},
			},
		},
	},
}: Queries.ParagraphSponsorMePromoCardDataFragment) => ({
	card: {
		text: field_promo_short_text,
		imgSrc,
		imgAlt,
		url: alias,
	},
});
export const ParagraphSponsorMePromoCard: React.FC<
	ParagraphSponsorMePromoCardProps
> = ({ card }) => {
	return (
		<WrappedSection sectionName="ParagraphSponsorMePromoCard">
			<div className={styles.inner}>
				<SponsorDogPromoCard {...card} />
			</div>
		</WrappedSection>
	);
};

export const fragment = graphql`
    fragment ParagraphSponsorMePromoCardData on paragraph__sponsor_me_promo_card {
        __typename
        id
        relationships {
            field_sponsor_dog {
                ...SponsorMePromoCardData
            }
        }
    }
    fragment SponsorMePromoCardData on node__sponsor_dog {
        field_promo_short_text
        id
        path {
            alias
        }
        relationships {
            field_featured_image {
                ...MediaImageData
            }
        }
    }
`;
